const variantSize = document.querySelector('[data-product-variants-size]').dataset.productVariantsSize;

if (variantSize == 1) {
  const href = new URL(window.location.href);
  const params = new URLSearchParams(href.search);
  const urlHasVariantId = params.has('variant');

  if (!urlHasVariantId) {
    const singleVariantId = document.querySelector('[data-product-single-variant-id]').dataset.productSingleVariantId;

    params.set('variant', singleVariantId);

    href.search = params.toString();
    window.history.replaceState(null, '', href.toString());
  }
}

// if (variantSize > 1) {
//   const href = new URL(window.location.href);
//   const params = new URLSearchParams(href.search);
//   // params.delete('variant');
//   href.search = params.toString();
//   window.history.replaceState(null, '', href.toString());
// } else {
//   const href = new URL(window.location.href);
//   const params = new URLSearchParams(href.search);
//   const urlHasVariantId = params.has('variant');

//   if (!urlHasVariantId) {
//     const singleVariantId = document.querySelector('[data-product-single-variant-id]').dataset.productSingleVariantId;
//     params.set('variant', singleVariantId);

//     href.search = params.toString();
//     window.history.replaceState(null, '', href.toString());
//   }
// }
